import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: ["border-2 border-gray-600 shadow-xl rounded-xl", _ctx.cls]
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}